'use client';

import { Fragment, useState } from 'react';

import { LineArrowDownIcon } from '@/app/_components/icons/line/LineArrowDownIcon';
import Skeleton from '@/app/(football)/[team]/_components/common/Skeleton';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import { useGetPointSaveWithInitQuery } from '@/store/server/common/football/football.query';

import EarnListItem from './EarnListItem';

const ITEMS_PER_PAGE = 5;

export default function EarnList() {
  const { originalsName } = useTeamConfig();

  const { data: pointSaveList, isLoading, isError } = useGetPointSaveWithInitQuery({ originalsName });

  const [page, setPage] = useState(1);
  const visibleList = pointSaveList?.rows?.slice(0, page * ITEMS_PER_PAGE);
  const hasMore = pointSaveList?.rows && visibleList && visibleList.length < pointSaveList.rows.length;

  if (isLoading) {
    return (
      <div className="mt-8 mb-10 flex w-full flex-col items-center gap-6">
        <div className="flex w-full flex-col gap-6">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={`skeleton-${index}`} className="flex w-full flex-col gap-6">
              <div className="flex w-full flex-row gap-4">
                <Skeleton width={120} height={120} borderRadius={4} />
                <div className="flex flex-1 flex-col justify-between gap-4">
                  <div className="flex flex-col gap-2">
                    <Skeleton width={100} height={22} />
                    <Skeleton width={200} height={20} />
                  </div>
                  <Skeleton width={100} height={32} borderRadius={4} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (isError || !pointSaveList) {
    return (
      <div className="mt-8 mb-10 flex w-full flex-col items-center gap-6">
        <div className="flex w-full items-center justify-center p-6 typo-body-2 text-white">
          데이터를 불러오는 중 오류가 발생했습니다.
        </div>
      </div>
    );
  }

  return (
    <div className="mt-8 mb-10 flex w-full flex-col items-center gap-6">
      <div className="flex w-full flex-col">
        {visibleList?.map((item, index) => (
          <Fragment key={item.methodIdx}>
            <EarnListItem
              methodIdx={item.methodIdx}
              methodCode={item.methodCode}
              title={item.title}
              image={item.image}
              point={item.point}
              link={item.link}
              offlineYn={item.offlineYn}
              startDttm={item.startDttm || 0}
              endDttm={item.endDttm || 0}
              hasCompleted={item.applyCount > 0}
            />
            {index < visibleList.length - 1 && (
              <div className="my-6 h-px w-full bg-point-lounge-list-divider" />
            )}
          </Fragment>
        ))}
      </div>
      {hasMore && (
        <button
          onClick={() => setPage((prev) => prev + 1)}
          className="flex items-center justify-center gap-1 border-none bg-none typo-body-6 text-white"
        >
          더보기
          <LineArrowDownIcon size={14} color="white" />
        </button>
      )}
    </div>
  );
}
